"use client";

import styles from "../css/components/universal-filter-tabs.module.css";

export default function FilterButtons({
  buttons = [],
  activeButton = null,
  onButtonClick = () => {},
  className = "",
}) {
  return (
    <div className={`${styles.container} ${className}`}>
      {buttons.map((button, index) => (
        <button
          key={index}
          onClick={() => onButtonClick(button)}
          className={`
            ${styles.button}
            ${activeButton === button ? styles.active : styles.inactive}
          `}
        >
          {button}
        </button>
      ))}
    </div>
  );
}
